import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getDynamicDataList } from '../../../../../services/api';
import Observer from '@researchgate/react-intersection-observer';
import styles from './index.css';
import Module from '../../module';

class Pingce extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        dataListArr: [],
    };

    async getDataListFn() {
        const { content } = this.props;
        const { pingceSlide } = content;

        try {
            const dataListArr = await getDynamicDataList('305868-');

            this.setState({
                dataListArr: dataListArr?.filter(item => item?.base62Id !== pingceSlide?.base62Id),
            });
        } catch (e) {
            console.error(e);
        }
    }

    handleChange = (event, unobserve) => {
        const { content } = this.props;
        const { isAsync } = content;

        if (event.isIntersecting) {
            unobserve();
            if (isAsync) {
                this.getDataListFn();
            }
        }
    };

    render() {
        const { content } = this.props;
        const { dataListArr } = this.state;
        const { pingceMd, pingceSlide, pingceFeed, pingceAd, isAsync } = content;

        const normalTabsData = pingceMd;
        const viewMoreLinkData = (pingceMd && pingceMd.moreTh) || '';
        const newsStreamData = isAsync ? dataListArr : pingceFeed;
        const mdBannerData = pingceSlide;

        if (normalTabsData) {
            normalTabsData.chipConfig = {
                id: '260707',
                type: 'struct',
                title: '评测子导航数据',
                groupName: 'content',
                translate: 'handleHomeTechMdInfo',
            };
        }
        if (mdBannerData) {
            mdBannerData.chipConfig = {
                id: '287963',
                type: 'recommend',
                title: '评测焦点图数据',
                groupName: 'content',
                translate: 'handleHomeTechSlideInfo',
            };
        }
        const moduleData = {
            normalTabsData,
            feedAd: null,
            mdBannerData,
            newsStreamData,
            viewMoreLinkData,
        };

        return (
            <Observer onChange={this.handleChange}>
                <section className={styles.pingce}>
                    <Module content={moduleData} />
                </section>
            </Observer>
        );
    }
}

export default errorBoundary(Pingce);
